import React from 'react';
import { Autocomplete, styled, TextField } from '@mui/material';
import { type Config, type FieldProps } from '@react-awesome-query-builder/mui';

import useSettings from '../../hooks/useSettings';

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
	'& > .MuiTextField-root > .MuiInputBase-root': {
		padding: 0,
		'& > .MuiInputBase-input': {
			padding: 8,
			paddingRight: 32
		}
	}
}));

export default function MaterialFieldSelect({ items, setField, selectedKey, readonly }: FieldProps<Config>) {
	const { t } = useSettings();

	const [value, setValue] = React.useState(items.find(item => item.key === selectedKey) || null);

	const onChange = (_e, selectedValue) => {
		if (selectedValue === undefined) return;
		setValue(selectedValue);
		setField(selectedValue?.path);
	};

	return (
		<StyledAutocomplete
			className="min-w-200"
			renderInput={params => (
				<TextField
					{...params}
					variant="outlined"
					size="small"
					// fullWidth
					autoComplete="off"
					InputLabelProps={{
						...params.InputLabelProps,
						shrink: true
					}}
				/>
			)}
			autoComplete={false}
			options={items}
			value={value}
			onChange={onChange}
			noOptionsText={t('LIST_NO_ITEMS')}
			isOptionEqualToValue={(option: any, fieldValue: any) => option.path === fieldValue.path}
			getOptionLabel={(option: any) => option.label || ''}
			getOptionDisabled={(option: any) => option.disabled}
			disabled={readonly}
			disableClearable
		/>
	);
}
